module.exports = __webpack_public_path__ + "img/icon-3.7634c9f8.png";